import api from '../interceptors/axiosInterceptor'
import API_CONFIG from '../config'

const NOTIFICATION_ENDPOINTS = {
  // اطلاع‌رسانی‌ها
  GET_ALL: '/notifications',
  GET_BY_ID: '/notifications',     // /notifications/{id}
  MARK_AS_READ: '/notifications/read', // /notifications/read/{id}
  MARK_ALL_READ: '/notifications/read-all',
  DELETE: '/notifications',        // /notifications/{id}
  CLEAR_ALL: '/notifications/clear-all',
  
  // انواع اطلاع‌رسانی
  TYPES: '/notifications/types',
  SETTINGS: '/notifications/settings',
  UPDATE_SETTINGS: '/notifications/settings',
  
  // اطلاع‌رسانی‌های سیستمی
  SYSTEM_NOTIFICATIONS: '/notifications/system',
  BROADCAST: '/notifications/broadcast',
  
  // اطلاع‌رسانی‌های پیامکی
  SMS: '/notifications/sms',
  SMS_BALANCE: '/notifications/sms/balance',
  SMS_TEMPLATES: '/notifications/sms/templates',
  
  // اطلاع‌رسانی‌های ایمیلی
  EMAIL: '/notifications/email',
  EMAIL_TEMPLATES: '/notifications/email/templates',
  SEND_EMAIL: '/notifications/email/send',
  
  // اطلاع‌رسانی‌های درون‌برنامه‌ای
  IN_APP: '/notifications/in-app',
  PUSH: '/notifications/push',
  PUSH_SUBSCRIBE: '/notifications/push/subscribe',
  PUSH_UNSUBSCRIBE: '/notifications/push/unsubscribe',
  
  // وب‌هوک
  WEBHOOKS: '/notifications/webhooks',
  WEBHOOK_TEST: '/notifications/webhooks/test',
  
  // آمار
  STATS: '/notifications/stats',
  UNREAD_COUNT: '/notifications/unread-count'
}

const NotificationService = {
  // ========== مدیریت اطلاع‌رسانی‌ها ==========
  
  // دریافت همه اطلاع‌رسانی‌های کاربر
  async getAllNotifications(params = {}) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.GET_ALL}`,
        { params }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت اطلاع‌رسانی توسط ID
  async getNotificationById(notificationId) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.GET_BY_ID}/${notificationId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // علامت‌گذاری به عنوان خوانده شده
  async markAsRead(notificationId) {
    try {
      const response = await api.patch(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.MARK_AS_READ}/${notificationId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // علامت‌گذاری همه به عنوان خوانده شده
  async markAllAsRead() {
    try {
      const response = await api.patch(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.MARK_ALL_READ}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // حذف اطلاع‌رسانی
  async deleteNotification(notificationId) {
    try {
      const response = await api.delete(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.DELETE}/${notificationId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // پاک کردن همه اطلاع‌رسانی‌ها
  async clearAllNotifications() {
    try {
      const response = await api.delete(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.CLEAR_ALL}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // ========== تنظیمات اطلاع‌رسانی ==========
  
  // دریافت انواع اطلاع‌رسانی
  async getNotificationTypes() {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.TYPES}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت تنظیمات اطلاع‌رسانی کاربر
  async getNotificationSettings() {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.SETTINGS}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // بروزرسانی تنظیمات اطلاع‌رسانی
  async updateNotificationSettings(settings) {
    try {
      const response = await api.put(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.UPDATE_SETTINGS}`,
        settings
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // ========== اطلاع‌رسانی‌های سیستمی ==========
  
  // دریافت اطلاع‌رسانی‌های سیستمی
  async getSystemNotifications(params = {}) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.SYSTEM_NOTIFICATIONS}`,
        { params }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // ارسال اطلاع‌رسانی گروهی (برای ادمین)
  async broadcastNotification(notificationData) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.BROADCAST}`,
        notificationData
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // ========== اطلاع‌رسانی پیامکی ==========
  
  // ارسال پیامک
  async sendSMS(phoneNumber, message, templateId = null) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.SMS}`,
        { phoneNumber, message, templateId }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت موجودی پیامک
  async getSMSBalance() {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.SMS_BALANCE}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت قالب‌های پیامک
  async getSMSTemplates() {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.SMS_TEMPLATES}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // ========== اطلاع‌رسانی ایمیلی ==========
  
  // دریافت قالب‌های ایمیل
  async getEmailTemplates() {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.EMAIL_TEMPLATES}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // ارسال ایمیل
  async sendEmail(to, subject, body, templateId = null) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.SEND_EMAIL}`,
        { to, subject, body, templateId }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // ========== اطلاع‌رسانی‌های درون‌برنامه‌ای ==========
  
  // دریافت اطلاع‌رسانی‌های درون‌برنامه‌ای
  async getInAppNotifications(params = {}) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.IN_APP}`,
        { params }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // ارسال نوتیفیکیشن پوش
  async sendPushNotification(notificationData) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.PUSH}`,
        notificationData
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // عضویت در پوش نوتیفیکیشن
  async subscribeToPush(subscriptionData) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.PUSH_SUBSCRIBE}`,
        subscriptionData
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // لغو عضویت از پوش نوتیفیکیشن
  async unsubscribeFromPush() {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.PUSH_UNSUBSCRIBE}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // ========== وب‌هوک ==========
  
  // مدیریت وب‌هوک‌ها
  async getWebhooks() {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.WEBHOOKS}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  async createWebhook(webhookData) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.WEBHOOKS}`,
        webhookData
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  async testWebhook(webhookId) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.WEBHOOK_TEST}/${webhookId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // ========== آمار و ابزارها ==========
  
  // دریافت آمار اطلاع‌رسانی‌ها
  async getNotificationStats(timeRange = 'month') {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.STATS}`,
        { params: { range: timeRange } }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // تعداد اطلاع‌رسانی‌های خوانده نشده
  async getUnreadCount() {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${NOTIFICATION_ENDPOINTS.UNREAD_COUNT}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // ========== ابزارهای کمکی ==========
  
  // ایجاد اطلاع‌رسانی جدید
  createNotification(type, title, message, data = {}) {
    const notificationTypes = {
      ORDER: 'order',
      PAYMENT: 'payment',
      SHIPMENT: 'shipment',
      PROMOTION: 'promotion',
      SYSTEM: 'system',
      SECURITY: 'security'
    }

    return {
      id: Date.now().toString(),
      type: notificationTypes[type] || type,
      title,
      message,
      data,
      isRead: false,
      createdAt: new Date().toISOString(),
      icon: this.getNotificationIcon(type)
    }
  },

  // دریافت آیکون مناسب برای نوع اطلاع‌رسانی
  getNotificationIcon(type) {
    const icons = {
      order: '🛒',
      payment: '💰',
      shipment: '🚚',
      promotion: '🎁',
      system: '🔔',
      security: '🔐',
      info: 'ℹ️',
      success: '✅',
      warning: '⚠️',
      error: '❌'
    }
    return icons[type] || '📢'
  },

  // فرمت‌دهی تاریخ اطلاع‌رسانی
  formatNotificationDate(dateString) {
    const date = new Date(dateString)
    const now = new Date()
    const diffMs = now - date
    const diffMins = Math.floor(diffMs / 60000)
    const diffHours = Math.floor(diffMins / 60)
    const diffDays = Math.floor(diffHours / 24)

    if (diffMins < 1) return 'همین الان'
    if (diffMins < 60) return `${diffMins} دقیقه پیش`
    if (diffHours < 24) return `${diffHours} ساعت پیش`
    if (diffDays < 7) return `${diffDays} روز پیش`
    
    return date.toLocaleDateString('fa-IR')
  },

  handleError(error) {
    if (error.response) {
      return {
        message: error.response.data.message || 'خطا در مدیریت اطلاع‌رسانی‌ها',
        status: error.response.status,
        data: error.response.data
      }
    }
    // ... مشابه قبلی
  }
}

export default NotificationService